// Human-readable file size, e.g. 1048576 -> "1.0 MB".
export function formatFileSize(bytes) {
  if (!bytes && bytes !== 0) return null
  const units = ['B', 'KB', 'MB', 'GB']
  let size = bytes
  let unit = 0
  while (size >= 1024 && unit < units.length - 1) {
    size /= 1024
    unit += 1
  }
  return `${size.toFixed(unit === 0 ? 0 : 1)} ${units[unit]}`
}

// Formats an ISO timestamp as a short Ukrainian date, e.g. "01.02.2026".
export function formatDate(isoString) {
  if (!isoString) return null
  const date = new Date(isoString)
  if (Number.isNaN(date.getTime())) return null
  return date.toLocaleDateString('uk-UA')
}
